<template lang="pug">
  .page(
    v-esc='closePopups'
    ref='page'
  )
    .page__middle
      .page__left(
        ref='leftSidebar'
        v-esc='hideSidebar'
      )
        button.page__close-sidebar(
          @click='hideSidebar'
        )
        .page__sidebar(
          v-click-outside='hideSidebar'
        )
          Sidebar

      .page__body
        .page__main
          .page__content
            router-view( v-if='status["ready"]' )

            page404( v-if='status["notFound"]' )
            page500( v-if='status["serviceError"]' )

            transition( name='fade' )
              Loader( v-if='status["loading"]' )

      .page__right
        .page__aside
          .page__search
            SearchField

          .page__promo
            Promo

    .page__bottom
      PlayerControls

    ModalList

</template>

<script>
import eventBus from "@/services/EventBus";
import { mapActions, mapGetters } from "vuex";

import page404 from "@/pages/404";
import page500 from "@/pages/500";

import Sidebar from "@/components/Sidebar/Sidebar";
import ModalList from "@/components/ModalList/ModalList";
import Confirm from "@/components/Confirm/Confirm";
import PlayerControls from "@/components/PlayerControls/PlayerControls";
import Promo from "@/components/Promo/Promo";
import SearchField from "@/components/SearchField/SearchField";
import Loader from "@/components/Loader/Loader";

import { DELAY_BEFORE_LOADING_INDICATOR } from "@/constants";

export default {
  name: "SongApp",
  data() {
    return {
      sidebarOpened: false
    };
  },
  computed: {
    ...mapGetters({
      pageStatus: "page/status",
      errorCode: "page/errorCode",
      passwordResetData: "user/passwordResetData"
    }),
    status() {
      return {
        init: this.pageStatus === "init",
        loading: this.pageStatus === "loading" || this.pageStatus === "init",
        notFound: this.errorCode === "notFound",
        serviceError: this.errorCode === "serviceError",
        ready: this.pageStatus !== "init" && !this.errorCode
      };
    }
  },
  components: {
    Sidebar,
    PlayerControls,
    ModalList,
    Confirm,
    Promo,
    SearchField,
    Loader,
    page404,
    page500
  },
  methods: {
    ...mapActions({
      closeModal: "modal/close",
      openModal: "modal/open",
      closeQueue: "page/closeQueue",
      setTitle: "page/setTitle",
      setStatus: "page/setStatus",
      setGenresListState: "page/setGenresListState",
      fetchPromo: "promo/fetch"
    }),
    closePopups() {
      this.closeModal();
      this.closeQueue();
    },
    showSidebar() {
      if (this.$refs.leftSidebar && !this.sidebarOpened) {
        setTimeout(() => {
          this.lockPage();
          this.$refs.leftSidebar.style.display = "block";
          this.sidebarOpened = true;
        });
      }
    },
    hideSidebar() {
      if (this.$refs.leftSidebar && this.sidebarOpened) {
        this.unlockPage();
        this.$refs.leftSidebar.style.display = null;
        this.sidebarOpened = false;
      }
    },
    lockPage() {
      const scrollbarWidth = window.innerWidth - document.body.clientWidth;
      this.$nextTick(() => {
        document.body.style.paddingRight = `${scrollbarWidth}px`;
        document.body.style.overflow = "hidden";
      });
    },
    unlockPage() {
      document.body.style.paddingRight = null;
      document.body.style.overflow = null;
    }
  },
  mounted() {
    let loadingTimeout = null;

    document.title = this.$l10n("LOADING");

    eventBus.$on("page:lock", () => this.lockPage());
    eventBus.$on("page:unlock", () => this.unlockPage());
    eventBus.$on("page:showSidebar", () => this.showSidebar());

    this.$router.beforeEach((to, from, next) => {
      loadingTimeout = setTimeout(() => {
        if (!this.status["init"]) {
          this.setStatus("loading");
        }
      }, DELAY_BEFORE_LOADING_INDICATOR);

      if (this.passwordResetData) {
        this.openModal({
          name: "resetPassword",
          data: this.passwordResetData
        });
      }

      if (this.sidebarOpened) {
        this.hideSidebar();
      }

      next();
    });

    this.$router.afterEach(() => {
      clearTimeout(loadingTimeout);

      this.closeQueue();
      this.setTitle();
      this.setStatus("ready");
      this.setGenresListState({
        type: null,
        title: null,
        visible: false
      });

      // if (this.$sidebarsInited) {
      //   this.$updateSidebars();
      // } else {
      //   this.$initSidebars(this.$refs.page);
      // }
    });

    this.fetchPromo();
  }
};
</script>
